import React from 'react'
import { cn } from 'ethcss'
import { palette, radius, shadow } from 'theme'
import styles from 'pages/ui/ui.jcss'
import grid from 'blocks.simple/grid/grid.jcss'

const SCALES = [
    { title: 'White', scale: palette.white, darkBg: true },
    { title: 'Black', scale: palette.black },
    { title: 'Neutral', scale: palette.neutral },
    { title: 'Brand Blue', scale: palette.brandBlue },
    { title: 'Info', scale: palette.info },
    { title: 'Warning', scale: palette.warning },
    { title: 'Error', scale: palette.error },
    { title: 'Success', scale: palette.success },
]

const Swatch = ({ step, value, darkBg }) => (
    <div className={styles.swatch}>
        <div className={cn(styles.swatchSquareWrap, darkBg && styles.swatchSquareWrapDark)}>
            <div className={styles.swatchSquare} style={{ backgroundColor: value }} />
        </div>
        <div className={styles.swatchStep}>{step}</div>
    </div>
)

const ScaleRow = ({ title, scale, darkBg }) => (
    <div className={styles.scaleRow}>
        <div className={styles.scaleTitle}>{title}</div>
        <div className={styles.scaleSwatches}>
            {Object.entries(scale).map(([step, value]) => (
                <Swatch key={step} step={step} value={value} darkBg={darkBg} />
            ))}
        </div>
    </div>
)

const UiPalette = () => (
    <div className={styles.blockPanel}>
        <div className={styles.title}>DS Palette</div>
        <div className={styles.paletteContent}>
            {SCALES.map((item) => (
                <ScaleRow key={item.title} {...item} />
            ))}
        </div>

        <div className={cn(styles.title, grid.mt_md)}>Radius</div>
        <div className={styles.radiusRow}>
            {Object.entries(radius).map(([name, value]) => (
                <div key={name} className={styles.radiusItem}>
                    <div className={styles.radiusBox} style={{ borderRadius: value }} />
                    <div className={styles.swatchStep}>{name}</div>
                    <div className={styles.tokenHint}>{value}</div>
                </div>
            ))}
        </div>

        <div className={cn(styles.title, grid.mt_md)}>Shadow</div>
        <div className={styles.shadowSection}>
            <div>
                <div className={styles.scaleTitle}>Black</div>
                <div className={styles.shadowRow}>
                    {Object.entries(shadow.black).map(([name, value]) => (
                        <div key={name} className={styles.shadowItem}>
                            <div className={styles.shadowBox} style={{ boxShadow: value }} />
                            <div className={styles.swatchStep}>{name}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className={styles.shadowSectionDark}>
                <div className={styles.shadowSectionDarkTitle}>White</div>
                <div className={styles.shadowRow}>
                    {Object.entries(shadow.white).map(([name, value]) => (
                        <div key={name} className={styles.shadowItem}>
                            <div className={cn(styles.shadowBox, styles.shadowBoxDark)} style={{ boxShadow: value }} />
                            <div className={styles.shadowSectionDarkStep}>{name}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </div>
)

export default UiPalette
